/**
 * Walk Paths
 * ------
 */

require('../vendor/imagesloaded.pkgd.min')

if($(".hero.is-home-hero-animated").length) {
    
    let heroGraphics = {
        1: $('.home-hero-piece-1'),
        2: $('.home-hero-piece-2'),
        3: $('.home-hero-piece-3'),
        4: $('.home-hero-piece-4'),
        5: $('.home-hero-piece-5'),
        6: $('.home-hero-piece-6'),
        7: $('.home-hero-piece-7'),
        8: $('.home-hero-piece-8'),
        9: $('.home-hero-piece-9'),
        10: $('.home-hero-piece-10'),
        11: $('.home-hero-piece-11'),
        12: $('.home-hero-piece-12'),
        13: $('.home-hero-piece-13'),
        14: $('.home-hero-piece-14'),
        15: $('.home-hero-piece-15'),
        16: $('.home-hero-piece-16'),
        17: $('.home-hero-piece-17'),
        18: $('.home-hero-piece-18'),
        19: $('.home-hero-piece-19'),
        20: $('.home-hero-piece-20'),
        21: $('.home-hero-piece-21'),
        22: $('.home-hero-piece-22'),
        23: $('.home-hero-piece-23'),
        24: $('.home-hero-piece-24'),
        25: $('.home-hero-piece-25'),
        26: $('.home-hero-piece-26'),
        27: $('.home-hero-piece-27'),
        28: $('.home-hero-piece-28'),
        29: $('.home-hero-piece-29'),
        30: $('.home-hero-piece-30'),
        31: $('.home-hero-piece-31')
    },
    heroOverlay = $('.hero-overlay'),
    walkingPath = $('.hero .walking-path'),
    introHasFinished = false;

    $('.hero.is-home-hero-animated').imagesLoaded(function () {
        setTimeout(function () {
            heroReveal(true);
        }, 500);
    });

    function heroReveal(isIntro) {

        setTimeout(function () {
            heroGraphics["1"].removeClass('hiding').addClass('bounce');
            heroGraphics["8"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["14"].removeClass('hiding').addClass('rubberBand');
            heroGraphics["24"].removeClass('hiding').addClass('shake');
        }, 100);

        setTimeout(function () {
            heroGraphics["27"].removeClass('hiding').addClass('bounce');
            heroGraphics["6"].removeClass('hiding').addClass('rubberBand');
            heroGraphics["2"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["30"].removeClass('hiding').addClass('shake');
            heroGraphics["25"].removeClass('hiding').addClass('swing');
        }, 500);

        setTimeout(function () {
            heroGraphics["3"].removeClass('hiding');
            heroGraphics["26"].removeClass('hiding');
            heroGraphics["16"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["31"].removeClass('hiding');
            heroGraphics["18"].removeClass('hiding');
            heroGraphics["11"].removeClass('hiding');
        }, 800);

        setTimeout(function () {
            heroGraphics["4"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["13"].removeClass('hiding');
            heroGraphics["21"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["29"].removeClass('hiding').addClass('jackInTheBox');
        }, 1100);

        setTimeout(function () {
            heroGraphics["5"].removeClass('hiding');
            heroGraphics["28"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["19"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["23"].removeClass('hiding');
        }, 1400);

        setTimeout(function () {
            heroGraphics["7"].removeClass('hiding');
            heroGraphics["22"].removeClass('hiding').addClass('jackInTheBox');
        }, 1600);

        setTimeout(function () {
            heroGraphics["9"].removeClass('hiding');
            heroGraphics["20"].removeClass('hiding');
        }, 1800);

        setTimeout(function () {
            heroGraphics["10"].removeClass('hiding');
            heroGraphics["17"].removeClass('hiding');
            if(isIntro) walkingPath.removeClass('hiding');
        }, 2000);

        setTimeout(function () {
            heroGraphics["12"].removeClass('hiding');
            heroGraphics["15"].removeClass('hiding').addClass('jackInTheBox');
        }, 2200);

        setTimeout(function () {
            if(isIntro) heroOverlay.removeClass('hiding');
        }, 2400);

        setTimeout(function () {
            // heroCycle();
            introHasFinished = true;
        }, 2700);

    }

    function heroCycle() {

        console.log('hero cycle started');



    }

    let heroCycleInterval = setInterval(function () {

        if(!introHasFinished) return;

        setTimeout(function () {
            heroGraphics["1"].addClass('hiding');
            heroGraphics["8"].addClass('hiding').removeClass('rotateIn');
            heroGraphics["14"].addClass('hiding').removeClass('rubberBand');
            heroGraphics["24"].addClass('hiding').removeClass('shake');
        }, 100);

        setTimeout(function () {
            heroGraphics["1"].removeClass('hiding');
            heroGraphics["8"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["14"].removeClass('hiding').addClass('rubberBand');
            heroGraphics["24"].removeClass('hiding').addClass('shake');
        }, 600);


        setTimeout(function () {
            heroGraphics["27"].addClass('hiding');
            heroGraphics["6"].removeClass('rubberBand');
            heroGraphics["2"].addClass('hiding').removeClass('rotateIn');
            heroGraphics["30"].addClass('hiding').removeClass('shake');
            heroGraphics["25"].addClass('hiding');
        }, 900);

        setTimeout(function () {
            heroGraphics["27"].removeClass('hiding');
            heroGraphics["6"].addClass('rubberBand');
            heroGraphics["2"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["30"].removeClass('hiding').addClass('shake');
            heroGraphics["25"].removeClass('hiding');
        }, 1400);


        setTimeout(function () {
            heroGraphics["3"].addClass('hiding');
            heroGraphics["26"].addClass('hiding');
            heroGraphics["16"].addClass('hiding').removeClass('jackInTheBox');
            heroGraphics["31"].addClass('hiding');
            heroGraphics["18"].addClass('hiding');
            heroGraphics["11"].addClass('hiding');
        }, 1500);

        setTimeout(function () {
            heroGraphics["3"].removeClass('hiding');
            heroGraphics["26"].removeClass('hiding');
            heroGraphics["16"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["31"].removeClass('hiding');
            heroGraphics["18"].removeClass('hiding');
            heroGraphics["11"].removeClass('hiding');
        }, 1900);


        setTimeout(function () {
            heroGraphics["4"].addClass('hiding').removeClass('rotateIn');
            heroGraphics["13"].addClass('hiding');
            heroGraphics["21"].addClass('hiding').removeClass('jackInTheBox');
            heroGraphics["29"].addClass('hiding').removeClass('jackInTheBox');
        }, 2000);

        setTimeout(function () {
            heroGraphics["4"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["13"].removeClass('hiding');
            heroGraphics["21"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["29"].removeClass('hiding').addClass('jackInTheBox');
        }, 2400);


        setTimeout(function () {
            heroGraphics["5"].addClass('hiding');
            heroGraphics["28"].addClass('hiding').removeClass('jackInTheBox');
            heroGraphics["19"].addClass('hiding').removeClass('rotateIn');
            heroGraphics["23"].addClass('hiding');
        }, 2300);

        setTimeout(function () {
            heroGraphics["5"].removeClass('hiding');
            heroGraphics["28"].removeClass('hiding').addClass('jackInTheBox');
            heroGraphics["19"].removeClass('hiding').addClass('rotateIn');
            heroGraphics["23"].removeClass('hiding');
        }, 2800);


        setTimeout(function () {
            heroGraphics["7"].addClass('hiding');
            heroGraphics["22"].addClass('hiding').removeClass('jackInTheBox');
        }, 2700);

        setTimeout(function () {
            heroGraphics["7"].removeClass('hiding');
            heroGraphics["22"].removeClass('hiding').addClass('jackInTheBox');
        }, 3200);


        setTimeout(function () {
            heroGraphics["9"].addClass('hiding');
            heroGraphics["20"].addClass('hiding');
        }, 3500);

        setTimeout(function () {
            heroGraphics["9"].removeClass('hiding');
            heroGraphics["20"].removeClass('hiding');
        }, 4000);


        setTimeout(function () {
            heroGraphics["10"].addClass('hiding');
            heroGraphics["17"].addClass('hiding');
        }, 4300);

        setTimeout(function () {
            heroGraphics["10"].removeClass('hiding');
            heroGraphics["17"].removeClass('hiding');
        }, 4700);


        setTimeout(function () {
            heroGraphics["12"].addClass('hiding');
            heroGraphics["15"].addClass('hiding').removeClass('jackInTheBox');
        }, 5000);

        setTimeout(function () {
            heroGraphics["12"].removeClass('hiding');
            heroGraphics["15"].removeClass('hiding').addClass('jackInTheBox');
        }, 5400);

    }, 6000);

    function heroCycleEnd() {
        clearInterval(heroCycleInterval);
    }

}